import { useState, useEffect } from "react";
import axios from "axios";

const useAdminData = () => {
  const [data, setData] = useState<any[]>([]);
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const urlApi = "https://analyse-feed-holub.onrender.com";

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      authenticateToken(token);
    } else {
      setLoading(false);
    }
  }, []);

  const authenticateToken = async (token: string) => {
    try {
      const response = await axios.get(urlApi + "/api/admin/feed-analyses", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data);
      setAuthenticated(true);
    } catch (error) {
      console.error("Authentication failed", error);
      localStorage.removeItem("token");
      setAuthenticated(false);
      setError("Authentication failed. Please login again.");
    } finally {
      setLoading(false);
    }
  };

  const login = async (password: string) => {
    try {
      const response = await axios.post(urlApi + "/api/login", { password });
      const receivedToken = response.data.token;
      localStorage.setItem("token", receivedToken);
      authenticateToken(receivedToken);
    } catch (error) {
      console.error("Login failed", error);
      setError("Incorrect password. Please try again.");
    }
  };

  return { data, authenticated, loading, error, login };
};

export default useAdminData;
